import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col, Card, CardHeader, CardTitle, CardBody } from 'reactstrap';
import FontAwesome from 'react-fontawesome';

import { getContentBlockItemsByName, getContentBlockItemByName } from '../../../Cms/CmsActions';

import FontCustom from '../../../../components/Content/FontCustom';
import CmsBlockItem from '../../../Cms/components/content/CmsBlockItem';


const PanelProductBenefits = ({ panel }) => {
    const title = (getContentBlockItemByName(panel.blocks, 'title') || {}).text || '';
    const subtitle = (getContentBlockItemByName(panel.blocks, 'subtitle') || {}).text || '';
    const image = getContentBlockItemByName(panel.blocks, 'image-stamp');

    return (
        <Container fluid className="px-2 px-md-0 py-3 bg-tertiary">
            <Container className="position-relative py-5">
                <div className="text-center">
                    <span className="text-uppercase text-primary text-lg">{subtitle}</span>
                    <span className="d-block h3">{title}</span>
                </div>
                {image && <CmsBlockItem item={image} type="image" className="position-absolute" style={{ bottom: 0, right: 0 }} />}

                <Row className="pt-3 pb-5">
                    {getContentBlockItemsByName(panel.blocks, 'benefits').map((benefit, index) => (
                        <Col key={index} xs="12" sm="6" md="4" lg="2">
                            <FontCustom name="check" size="2" className="d-block mb-2 text-secondary" />
                            <CmsBlockItem item={benefit} type="html" />
                        </Col>
                    ))}
                </Row>
            </Container>
        </Container>
    );
};

PanelProductBenefits.propTypes = {
    panel: PropTypes.object.isRequired,
};

export default PanelProductBenefits;

export const PanelProductBenefitsModel = {
    type: 'panel',
    name: 'productBenefits',
    blocks: [
        {
            name: 'subtitle',
            type: 'text',
            max: 1,
        },
        {
            name: 'title',
            type: 'text',
            max: 1,
        },
        {
            name: 'image-stamp',
            type: 'image',
            max: 1,
        },
        {
            name: 'benefits',
            type: 'html',
        },
    ],
};
